import { showHinweis } from "../../components/merkzettel-hinweis/showHinweis.js";
import { sendCustomEvent } from "./utils/events.js";
import { sendMerkenherzUpdateEvent } from "./merkenHerzUpdateEvent.js";
import { appCallbackEntmerken } from "./app-callbacks/entmerken.js";
import {
    MERKZETTEL_ENTFERNEN_EVENT,
    MERKZETTEL_UPDATE_EVENT,
    MERKZETTEL_KUNDENLISTE_ARTIKEL_ENTFERNT_EVENT,
    MERKZETTEL_ARTIKELLISTE_UPDATE_EVENT
} from "./merkzettel-events.js";

const HINWEIS_QUELLE = "ArtikelEntfernen - handlesubmit";

/** Führt den DELETE-Request aus und wirft bei nicht-ok Antwort; gibt die Response zurück. */
export async function artikelLoeschen(action) {
    const response = await fetch(action, {
        method: "DELETE",
        credentials: "same-origin"
    });
    if (!response.ok) {
        throw new Error(response.statusText);
    }
    return response;
}

/**
 * Nebenwirkungen, nachdem ein Artikel vollständig (Merkzettel + alle Listen) entfernt wurde:
 * Herz zurück auf "unmarked", App-Callback, Merkzettel-Events, Listendarstellung aktualisieren, Erfolgshinweis.
 *
 * hinweisContainer: Ziel für den Erfolgshinweis. Steht das Merkenherz in einem Dialog,
 * übergibt der Aufrufer diesen Dialog, damit der Hinweis dort rendert statt auf der Seite.
 *
 * zeigeErfolgsHinweis: false unterdrückt den Hinweis, z. B. wenn das Merkenherz in einer App-Webview steckt.
 */
export function verarbeiteVollstaendigesEntfernen({ target, artikelnummer, listEntry, hinweisContainer = document.body, zeigeErfolgsHinweis = true }) {
    appCallbackEntmerken(artikelnummer);
    sendMerkenherzUpdateEvent(target, artikelnummer, "unmarked");
    sendCustomEvent(MERKZETTEL_ENTFERNEN_EVENT);
    sendCustomEvent(MERKZETTEL_UPDATE_EVENT);
    entferneAusListenDarstellung(listEntry);
    if (zeigeErfolgsHinweis) {
        showHinweis("success-remove", hinweisContainer, HINWEIS_QUELLE);
    }
}

/**
 * Nebenwirkungen, nachdem ein Artikel aus einer einzelnen Kundenliste entfernt wurde.
 * Bewusst kein Herz-Update: der Artikel kann weiterhin auf dem Merkzettel oder anderen Listen liegen.
 */
export function verarbeiteEinzellistenEntfernen({ listEntry }) {
    sendCustomEvent(MERKZETTEL_KUNDENLISTE_ARTIKEL_ENTFERNT_EVENT);
    entferneAusListenDarstellung(listEntry);
    showHinweis("success-remove", document.body, HINWEIS_QUELLE);
}

function entferneAusListenDarstellung(listEntry) {
    sendCustomEvent(MERKZETTEL_ARTIKELLISTE_UPDATE_EVENT, {
        removeFromDOM: true,
        targetToBeRemoved: listEntry
    });
}
